export default __webpack_public_path__ + "media/zurb/img/party/flame-0acb6767084f20f911aefe769c17f339.jpg";